import Datatable, {DEFAULT_PAGINATE} from "components/DataTable/Datatable";
import Logo from 'assets/images/logo.png'
import {clientRequest} from "../../common/clientRequest";
import {useEffect, useState} from "react";
import HomeFilter, {IHomeFilter} from "./Home.filter";
import {IPagination} from "../../components/DataTable/Datatable.interface";
import {countryCodeObj} from "../../constants/countryCode";
import useQueryParams from "../../hooks/useQueryParams";
import {message} from "../../common/commons";

import canadaData from 'assets/states/canada.json';
import usData from 'assets/states/us.json';

const canadaList = JSON.parse(JSON.stringify(canadaData));
const usList = JSON.parse(JSON.stringify(usData));

export const Home = () => {
  const [queryParam, setQueryParamsAndPush] = useQueryParams()
  const [companies, setCompanies] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState<IPagination>({total: 0})

  const fetching = async (filters: any = {}, limit: number = DEFAULT_PAGINATE.limit, offset: number = 0) => {
    setLoading(true)
    try {
      const data = await clientRequest({
        body: {
          "query": `query GetCompanies($where: _custom_list_company_bool_exp, $limit: Int, $offset: Int) {
  listCompany: _custom_list_company(limit: $limit, offset: $offset, order_by: {company_name: asc}, where: $where) {
    address
    business_phone
    city
    company_name
    country
    postal_code
    state
  }
  listCompanyAggregate: _custom_list_company_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}`,
          "variables": {
            "limit": limit,
            "offset": offset,
            "where": filters
          },
          "operationName": "GetCompanies"
        },
        method: 'POST'
      })
      if (data.errors) {
        throw data.errors
      }
      setCompanies(data.data.listCompany)
      setPaginate({
        total: data.data?.listCompanyAggregate?.aggregate?.count || 0,
      })
    } catch (errors: any) {
      console.log(errors)
      message('error', errors[0].message)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (!queryParam.page || !queryParam.limit) {
      setQueryParamsAndPush({
        page: queryParam.page || DEFAULT_PAGINATE.page,
        limit: queryParam.limit || DEFAULT_PAGINATE.limit
      })
      return
    }
    const {limit: _l, page: _p, ...filterValues} = queryParam;
    const requiredFields = ['companyName', 'businessPhone', 'address', 'postalCode', 'city', 'state'];
    const hasRequiredFilter = requiredFields.some((field: string) => filterValues[field] !== undefined && filterValues[field] !== null && filterValues[field] !== '');
    if (hasRequiredFilter) {
      const limit = parseInt(queryParam.limit) || DEFAULT_PAGINATE.limit
      const page = parseInt(queryParam.page) || DEFAULT_PAGINATE.page
      const offset = limit * (page - 1)
      fetching(convertValueFilter(filterValues as IHomeFilter), limit, offset)
    }
    // eslint-disable-next-line
  }, [queryParam])

  const onFilter = (values: any) => {
    if (!values || Object.keys(values).length === 0) return;
    const {limit: _l, page: _p, ...filterValues} = values;
    const requiredFields = ['companyName', 'businessPhone', 'address', 'postalCode', 'city', 'state'];
    const hasRequiredFilter = requiredFields.some((field) => filterValues[field] !== undefined && filterValues[field] !== null && filterValues[field] !== '');
    if (!hasRequiredFilter) return;
    setQueryParamsAndPush({...queryParam, ...values, page: 1}, true)
  }

  const onClear = () => {
    setCompanies([])
    setPaginate({total: 0})
  }

  const convertValueFilter = (filters: IHomeFilter) => {
    let filtersConvert: { [key: string]: any } = {}
    Object.keys(filters).map(filterKey => {
      if (!filters[filterKey as keyof typeof filters]) return filterKey
      switch (filterKey) {
        case 'companyName':
          filtersConvert['company_name_2'] = {_eq: filters[filterKey]?.toLowerCase()}
          break
        case 'businessPhone':
          filtersConvert['business_phone'] = {_eq: filters[filterKey]}
          break
        case 'city':
          filtersConvert['city_2'] = {_eq: filters[filterKey]?.toLowerCase()}
          break
        case 'state':
          filtersConvert['state_2'] = {_eq: filters[filterKey]?.toLowerCase()}
          break
        case 'country':
          filtersConvert['country'] = {_eq: filters[filterKey]}
          break
        case 'address':
          filtersConvert['address_2'] = {_eq: filters[filterKey]?.toLowerCase()}
          break
        case 'postalCode':
          filtersConvert['postal_code_2'] = {_eq: filters[filterKey]?.toLowerCase()}
          break
      }
      return filterKey
    })
    return filtersConvert
  }

  return (
    <div className="w-full py-2 md:px-6 lg:px-8 pt-8 pb-10">
      <div className="sm:flex sm:items-center px-5 sm:px-0">
        <div className="sm:flex-auto">
          <div className={'flex justify-center'}>
            <img src={Logo} alt="" className={'w-10'}/>
            <h2 className="ml-4 text-center text-2xl font-black" style={{color: 'rgb(16, 45, 89)'}}>Fastboy</h2>
          </div>
          <p className="mt-2 text-sm text-gray-700 text-center">
            A list of all the client company of Fastboy.
          </p>
        </div>
      </div>
      <HomeFilter onFilter={(values) => onFilter(values)} onClear={() => onClear()}/>

      <div id={'post-container'} className={'w-full'}></div>

      <Datatable
        loading={loading}
        dataSource={companies}
        pagination={{
          total: paginate.total,
        }}
        columns={[
          {
            title: 'Company Name',
            dataIndex: 'company_name',
            width: 200
          },
          {
            title: 'Business Phone',
            dataIndex: 'business_phone',
            width: 200,
            render: (value) => <span>{value ? `******${value}` : '-'}</span>
          },
          {
            title: 'City',
            dataIndex: 'city',
            width: 200
          },
          {
            title: 'State',
            dataIndex: 'state',
            width: 200,
            render: (value, record) => {
              if (record.country === 'US' || record.country === 'CA') {
                const stateList = record.country === 'US' ? usList : canadaList
                const currentState = stateList.find((item: any) => item.abbreviation === value)
                if (currentState) {
                  return <span>{currentState.name}</span>
                } else {
                  return <span>{value}</span>
                }
              } else {
                return <span>{value}</span>
              }
            }
          },
          {
            title: 'Country',
            dataIndex: 'country',
            width: 200,
            render: (value) => {
              return <div>{countryCodeObj[value as keyof typeof countryCodeObj]?.name || value}</div>
            }
          },
          {
            title: 'Address',
            dataIndex: 'address',
            width: 250
          },
          {
            title: 'Postal Code',
            dataIndex: 'postal_code',
            width: 150,
          }
        ]}
      />

    </div>
  )
}

export default Home;